import { useQuery } from "@tanstack/react-query";
import { rankingApi } from "@bw/shared/api";
import type { PlayerRatingResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The authenticated player's own rating (GET /ranking/rating). Server-scoped to
 * the token user — no argument. Rendered verbatim by RatingCard.
 *
 * `enabled` (default true) lets a PUBLIC-BROWSE caller gate the fetch on auth
 * state. The player home mounts for an anonymous visitor too, so the HomePage
 * passes `Boolean(user)` — this token-scoped read must NOT fire when logged out
 * (it would 401). The guarded /compete hub leaves the default `true`.
 */
export function useMyRating(enabled = true) {
  return useQuery<PlayerRatingResponse>({
    queryKey: queryKeys.compete.myRating(),
    queryFn: () => rankingApi.getMyRating(),
    enabled,
  });
}
